import axios from 'axios'
import { baseURL } from './data'

const api = axios.create({
  baseURL: baseURL
})

api.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('client-admisi-token')
    token ? config.headers['Authorization'] = `Bearer ${token}` : false
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default api



// WEBPACK FOOTER //
// ./src/api/index.js